var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_142_84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79128 0.947266H7.7877C3.84101 0.947266 0.631592 4.15758 0.631592 8.10516C0.631592 9.67095 1.13622 11.1222 1.99428 12.3006L1.10222 14.9597L3.85354 14.0802C4.98538 14.83 6.33554 15.2631 7.79128 15.2631C11.738 15.2631 14.9474 12.0518 14.9474 8.10516C14.9474 4.15848 11.738 0.947266 7.79128 0.947266ZM11.9563 11.0551C11.7836 11.5427 11.0982 11.9472 10.5515 12.0653C10.1775 12.1449 9.68901 12.2084 8.04449 11.5266C5.94096 10.6552 4.58633 8.51763 4.48075 8.37895C4.37964 8.24027 3.63075 7.24711 3.63075 6.21995C3.63075 5.19279 4.15238 4.69263 4.36264 4.4779C4.53533 4.30163 4.82075 4.22111 5.09454 4.22111C5.18312 4.22111 5.26275 4.22558 5.33433 4.22916C5.54459 4.23811 5.65017 4.25063 5.78885 4.58258C5.96154 4.99863 6.38207 6.02579 6.43217 6.13137C6.48317 6.23695 6.53417 6.38011 6.46259 6.51879C6.39549 6.66195 6.33643 6.72548 6.23085 6.84716C6.12528 6.96884 6.02507 7.0619 5.91949 7.19253C5.82285 7.30616 5.7137 7.42784 5.83538 7.63811C5.95707 7.8439 6.37759 8.53016 6.99675 9.08132C7.79575 9.79263 8.44354 10.0199 8.67528 10.1165C8.84796 10.1881 9.05375 10.1711 9.17991 10.0369C9.34007 9.86421 9.5378 9.5779 9.73912 9.29605C9.88228 9.09384 10.063 9.06879 10.2527 9.14037C10.446 9.20748 11.4686 9.713 11.6789 9.81769C11.8892 9.92327 12.0279 9.97337 12.0789 10.0619C12.129 10.1505 12.129 10.5666 11.9563 11.0551Z",
    fill: "#39373A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_142_84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3158,
    height: 14.3158,
    fill: "white",
    transform: "translate(0.631592 0.947266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.cc867b6eceeb51f59bdea2077b750245.svg";
export { ForwardRef as ReactComponent };